export default function accountUsersEndpointConverter({
  data = [],
  included = [],
}) {
  // There is always only one included user
  const user = included
    .filter((p) => p.type === 'users')
    .map((user) => ({
      id: user.id,
      name: user.attributes.name,
      email: user.attributes.email,
    }))[0]

  const apiKeysByAccountId = data
    .filter((p) => p.type === 'account-users')
    .reduce((acc, p) => {
      acc[p.relationships.account.data.id] = p.attributes['api-key']
      return acc
    }, {})

  const allowedRoles = ['admin', 'angel', 'property_manager'];

  const accountList = included
  .filter(
    (p) =>
      p.type === 'accounts' &&
        allowedRoles.includes(p.attributes.role)
  )
  .map((p) => ({
    id: p.id,
    role: p.attributes.role,
    name: p.attributes.name,
    apiKey: apiKeysByAccountId[p.id],
  }))

  const hasTenantAccess =
    included.filter(
      (p) => p.type === 'accounts' && p.attributes.role === 'tenant'
    ).length > 0

  if (accountList.length === 0) {
    if (hasTenantAccess) {
      throw new Error(
        'Du har ikke adgang til nogen administratorkonti — log på app.wisehome.dk for beboeradgang.'
      )
    } else {
      throw new Error('Du har ikke adgang til nogen administratorkonti.')
    }
  }

  return {
    user,
    accountList,
  }
}
